import { createClient } from "@supabase/supabase-js";

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;
const SUPABASE_SINGLETON_KEY = "__tiwani_supabase_client__";
const runtimeScope = typeof window !== "undefined" ? window : {};
const hasValidHttpUrl = (() => {
  try {
    const parsed = new URL(String(supabaseUrl || ""));
    return parsed.protocol === "http:" || parsed.protocol === "https:";
  } catch {
    return false;
  }
})();

const hasConfiguredEnv =
  hasValidHttpUrl &&
  Boolean(supabaseAnonKey) &&
  !String(supabaseUrl).includes("your_supabase_project_url_here") &&
  !String(supabaseAnonKey).includes("your_supabase_publishable_or_anon_key_here");

if (!hasConfiguredEnv) {
  console.warn(
    "[Tiwani] Supabase env vars are missing or invalid. Use your HTTPS project URL and browser-safe anon/publishable key in .env."
  );
}

export const isSupabaseConfigured = hasConfiguredEnv;

function createSupabaseClient() {
  return createClient(
    hasConfiguredEnv ? supabaseUrl : "https://placeholder.supabase.co",
    hasConfiguredEnv ? supabaseAnonKey : "placeholder-key",
    {
      auth: {
        persistSession: false,
        autoRefreshToken: false,
        detectSessionInUrl: false,
      },
    }
  );
}

export const supabase =
  runtimeScope[SUPABASE_SINGLETON_KEY] || (runtimeScope[SUPABASE_SINGLETON_KEY] = createSupabaseClient());
